<template>
    <q-scroll-area id="app-menu">
        <div id="searchbox" class="q-pa-xs bg-grey-2">
            <img src="/img/pmmc.png" alt="Brasão da Prefeitura de Mogi das Cruzes" height="40" class="on-right">
        </div>

        <q-item clickable icon="dashboard" class="top-level" :to="{ name: 'dashboard' }">
            <q-item-section avatar>
                <q-icon color="primary" name="dashboard" />
            </q-item-section>
            <q-item-section>
                {{ $t('dashboard') }}
            </q-item-section>
        </q-item>

        <q-expansion-item group="somegroup" label="Assistência Social" icon="group" class="top-level">
            <q-list>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'cras' }"
                    v-if="can('cras.menu')">
                    <q-item-section>
                        CRAS
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'creas' }"
                    v-if="can('creas.menu')">
                    <q-item-section>
                        CREAS
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'conselhoTutelar' }"
                v-if="can('conselho-tutelar.menu')">
                <q-item-section>
                    Conselho Tutelar
                </q-item-section>
            </q-item>
            </q-list>
        </q-expansion-item>

        <q-expansion-item group="somegroup" label="Unidade" icon="room" class="top-level">
            <q-list>
                <q-item class="text-weight-bold" clickable :insetLevel="1" dense :to="{ name: 'unidade' }"
                    v-if="can('unidade.menu')">
                    <q-item-section>
                        Unidade
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'unidadeCategoria' }"
                    v-if="can('unidade-categoria.menu')">
                    <q-item-section>
                        Categoria
                    </q-item-section>
                </q-item>
            </q-list>
        </q-expansion-item>

        <q-expansion-item group="somegroup" label="Indicador" icon="assessment" class="top-level"
            v-if="can('indicador.menu')">
            <q-list>
                <q-item class="text-weight-bold" clickable :insetLevel="1" dense :to="{ name: 'indicador' }"
                    v-if="can('indicador.menu')">
                    <q-item-section>
                        Indicador
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'indicadorCategoria' }"
                    v-if="can('indicador-categoria.menu')">
                    <q-item-section>
                        Categoria
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'indicadorSegmento' }"
                    v-if="can('indicador-segmento.menu')">
                    <q-item-section>
                        Segmento
                    </q-item-section>
                </q-item>
                <q-separator inset="item" />
                <q-item clickable :insetLevel="1" dense :to="{ name: 'informacoes' }" v-if="can('informacoes.menu')">
                    <q-item-section>
                        Informações
                    </q-item-section>
                </q-item>
            </q-list>
        </q-expansion-item>

        <q-expansion-item group="somegroup" label="Funcionário" icon="perm_contact_calendar" class="top-level"
            v-if="can('funcionario.menu')">
            <q-list>
                <q-item class="text-weight-bold" clickable :insetLevel="1" dense :to="{ name: 'funcionario' }"
                    v-if="can('funcionario.menu')">
                    <q-item-section>
                        Funcionário
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'cargo' }" v-if="can('cargo.menu')">
                    <q-item-section>
                        Cargo
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'funcao' }" v-if="can('funcao.menu')">
                    <q-item-section>
                        Função
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'escolaridade' }" v-if="can('escolaridade.menu')">
                    <q-item-section>
                        Escolaridade
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'profissao' }" v-if="can('profissao.menu')">
                    <q-item-section>
                        Profissão
                    </q-item-section>
                </q-item>
                <!-- <q-item clickable :insetLevel="1" dense :to="{ name: 'posgraduacao' }" v-if="can('posgraduacao.menu')">
                    <q-item-section>
                        Pós-graduação
                    </q-item-section>
                </q-item> -->
                <q-item clickable :insetLevel="1" dense :to="{ name: 'vinculo' }" v-if="can('vinculo.menu')">
                    <q-item-section>
                        Vínculo
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'cargaHoraria' }" v-if="can('cargahoraria.menu')">
                    <q-item-section>
                        Carga Horária
                    </q-item-section>
                </q-item>
                <!-- <q-item clickable :insetLevel="1" dense :to="{ name: 'fontePagadora' }" v-if="can('fontepagadora.menu')">
                    <q-item-section>
                        Fonte Pagadora
                    </q-item-section>
                </q-item> -->
                <!-- <q-item clickable :insetLevel="1" dense :to="{ name: 'servico' }" v-if="can('servico.menu')">
                    <q-item-section>
                        Serviço
                    </q-item-section>
                </q-item> -->
                <!-- <q-item clickable :insetLevel="1" dense :to="{ name: 'status' }" v-if="can('status.menu')">
                    <q-item-section>
                        Status
                    </q-item-section>
                </q-item> -->
                <q-item clickable :insetLevel="1" dense :to="{ name: 'corRaca' }" v-if="can('cor-raca.menu')">
                    <q-item-section>
                        Cor Raça
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'graduacao' }" v-if="can('graduacao.menu')">
                    <q-item-section>
                        Graduação
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'beneficio' }" v-if="can('beneficio.menu')">
                    <q-item-section>
                        Benefício
                    </q-item-section>
                </q-item>

            </q-list>
        </q-expansion-item>

        <q-separator />
        <q-expansion-item group="somegroup" label="Administrador" icon="settings" class="top-level">
            <q-list>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'user' }" v-if="can('user.menu')">
                    <q-item-section>
                        Usuário
                    </q-item-section>
                </q-item>
                <!-- <q-item clickable :insetLevel="1" dense :to="{ name: 'permissao' }" v-if="can('permissao.menu')">
                    <q-item-section>
                        Permissão
                    </q-item-section>
                </q-item> -->
                <q-item clickable :insetLevel="1" dense :to="{ name: 'bairro' }" v-if="can('bairro.menu')">
                    <q-item-section>
                        Bairro
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'secretaria' }" v-if="can('secretaria.menu')">
                    <q-item-section>
                        Secretaria
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'conteudo' }" v-if="can('conteudo.menu')">
                    <q-item-section>
                        Conteúdo
                    </q-item-section>
                </q-item>
                <q-item clickable :insetLevel="1" dense :to="{ name: 'atualizacao' }" v-if="can('atualizacao.menu')">
                    <q-item-section>
                        Atualização
                    </q-item-section>
                </q-item>

            </q-list>
        </q-expansion-item>

    </q-scroll-area>
</template>

<script>
    export default {
        methods: {

            can(acao) {
                if (this.$store.getters['auth/acl']) {
                    if (this.$store.getters['auth/acl'].indexOf(acao) >= 0) return true
                }
                return false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/Drawer.vue